// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsSetAlertChannelBody = {
  alertKind:
    | "poolInvite"
    | "contestStarted"
    | "contestFinished"
    | "seasonStarted"
    | "poolSettingsChanged"
    | "pickReminder"
    | "roundGraded"
    | "eliminated"
    | "revived"
    | "spreadMoved"
    | "customAwardChanged"
    | "squaresLockUnlock"
    | "squaresGridPublished"
    | "squaresWinnerSet"
    | "squaresWinnerUpdated"
    | "squaresSquareAssigned"
    | "squaresScoreCorrection"
    | "stripCardLockUnlock"
    | "memberWaitingApproval"
    | "gameStart"
    | "gameEnd"
    | "gameMoment"
    | "chatMessage"
    | "chatReaction"
    | "messageRequest"
    | "chatClosed"
    | "roundLocked"
    | "contestCorrected"
    | "stripCardStripAdded"
    | "stripCardFilled"
    | "stripCardSpotAssigned"
    | "stripCardSpotUnassigned"
    | "stripCardWinner"
    | "stripCardGameCanceled"
    | "fanFollowRequest"
    | "fanFollowNew"
    | "fanFollowAccepted";
  channel: "email" | "inApp" | "phone";
  isEnabled: boolean;
};

export type typeNotificationSettingsSetAlertChannelOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    alertKind:
      | "poolInvite"
      | "contestStarted"
      | "contestFinished"
      | "seasonStarted"
      | "poolSettingsChanged"
      | "pickReminder"
      | "roundGraded"
      | "eliminated"
      | "revived"
      | "spreadMoved"
      | "customAwardChanged"
      | "squaresLockUnlock"
      | "squaresGridPublished"
      | "squaresWinnerSet"
      | "squaresWinnerUpdated"
      | "squaresSquareAssigned"
      | "squaresScoreCorrection"
      | "stripCardLockUnlock"
      | "memberWaitingApproval"
      | "gameStart"
      | "gameEnd"
      | "gameMoment"
      | "chatMessage"
      | "chatReaction"
      | "messageRequest"
      | "chatClosed"
      | "roundLocked"
      | "contestCorrected"
      | "stripCardStripAdded"
      | "stripCardFilled"
      | "stripCardSpotAssigned"
      | "stripCardSpotUnassigned"
      | "stripCardWinner"
      | "stripCardGameCanceled"
      | "fanFollowRequest"
      | "fanFollowNew"
      | "fanFollowAccepted";
    channel: "email" | "inApp" | "phone";
    isEnabled: boolean;
  };
};

export type typeNotificationSettingsSetAlertChannelOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetAlertChannelOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetAlertChannelOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsSetAlertChannelBody = {
  type: "object",
  properties: {
    alertKind: {
      type: "string",
      enum: [
        "poolInvite",
        "contestStarted",
        "contestFinished",
        "seasonStarted",
        "poolSettingsChanged",
        "pickReminder",
        "roundGraded",
        "eliminated",
        "revived",
        "spreadMoved",
        "customAwardChanged",
        "squaresLockUnlock",
        "squaresGridPublished",
        "squaresWinnerSet",
        "squaresWinnerUpdated",
        "squaresSquareAssigned",
        "squaresScoreCorrection",
        "stripCardLockUnlock",
        "memberWaitingApproval",
        "gameStart",
        "gameEnd",
        "gameMoment",
        "chatMessage",
        "chatReaction",
        "messageRequest",
        "chatClosed",
        "roundLocked",
        "contestCorrected",
        "stripCardStripAdded",
        "stripCardFilled",
        "stripCardSpotAssigned",
        "stripCardSpotUnassigned",
        "stripCardWinner",
        "stripCardGameCanceled",
        "fanFollowRequest",
        "fanFollowNew",
        "fanFollowAccepted",
      ],
    },
    channel: { type: "string", enum: ["email", "inApp", "phone"] },
    isEnabled: { type: "boolean" },
  },
  required: ["alertKind", "channel", "isEnabled"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsSetAlertChannel(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(
      schemaNotificationSettingsSetAlertChannelBody,
    );
  }

  return async function postNotificationSettingsSetAlertChannel(
    payload: typeNotificationSettingsSetAlertChannelBody,
  ): Promise<
    | typeNotificationSettingsSetAlertChannelOutput200
    | typeNotificationSettingsSetAlertChannelOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsSetAlertChannel" failed before calling the network. #5b17395cfaeb`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5b17395cfaeb" },
        },
        data: null,
      } as typeNotificationSettingsSetAlertChannelOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/set-alert-channel`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsSetAlertChannelOutput200
      | typeNotificationSettingsSetAlertChannelOutput400;
  };
}
